var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_84_265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_84_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9463 12.5L8.87301 8.42701C8.73468 8.28851 8.66385 8.11443 8.66051 7.90476C8.65735 7.69526 8.72818 7.51801 8.87301 7.37301C9.01801 7.22818 9.19368 7.15576 9.40001 7.15576C9.60634 7.15576 9.78201 7.22818 9.92701 7.37301L14.4213 11.8673C14.5148 11.9609 14.5808 12.0597 14.6193 12.1635C14.6578 12.2673 14.677 12.3795 14.677 12.5C14.677 12.6205 14.6578 12.7327 14.6193 12.8365C14.5808 12.9403 14.5148 13.0391 14.4213 13.1328L9.92701 17.627C9.78851 17.7653 9.61443 17.8362 9.40476 17.8395C9.19526 17.8427 9.01801 17.7718 8.87301 17.627C8.72818 17.482 8.65576 17.3063 8.65576 17.1C8.65576 16.8937 8.72818 16.718 8.87301 16.573L12.9463 12.5Z",
    fill: "#1C1B1F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/Right_arrow.3334ba311e2208006caf1fd4e25f5e98.svg";
export { ForwardRef as ReactComponent };